<div class="position-relative">
  <div class="main-container input position-relative" (click)="toggleDropdown($event)" style="cursor: pointer;">
    <p class="value mb-0">{{ selectedCountry?.name || 'Select Country' }}</p>
  </div>
  <!-- Dropdown list -->
  <div class="abs-container" *ngIf="isDropdownVisible" (click)="$event.stopPropagation()">
    <div class="list-main-container">
      <div class="search-container">
        <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="searchQuery"
          (input)="filterCountries()" autofocus />
      </div>
      <div class="list-container">
        <div class="list-item" *ngFor="let country of filteredCountries" (click)="selectCountry(country)">
          <p class="name">{{ country.name }}</p>
        </div>
      </div>
    </div>
  </div>
</div>